import React, { Component } from 'react'
import ListApp from './list'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux';
import * as actions from '../../store/pseudo/general';
import { withRouter } from 'react-router-dom';
import { getSearchHistory, saveSearchHistoryEntry, removeSearchHistoryEntry } from '../../utils/searchHistory';

class SearchMenuBar extends Component {
  
  // ############################ CONSTRUCTOR ###################################
  // ############################ CONSTRUCTOR ###################################
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      selectedItem: -1,
      isFocused: false,
      searchHistory: []
    };
  }

  componentDidMount() {
    this.refreshSearchHistory();
  }

  
  // ############################ CONSTRUCTOR ###################################
  // ############################ CONSTRUCTOR ###################################
  render() {

    const { type, suggestions, onSubmit, onFocus, boxStyle, loading } = this.props;
    const suggestionsList = (Array.isArray(suggestions) ? suggestions : []);
    const isHistoryMode = !this.state.value || this.state.value.trim().length === 0;
    const showFilter = this.props.showFilter !== false;
    const activeList = this.getActiveSearchList(suggestionsList);
    const showSuggestions = this.state.isFocused && activeList.length > 0;

    return (
      <div className={"BRL " + boxStyle + " map-search-wrap" + (showSuggestions ? " has-suggestions" : "")}>
        <div className={"map-search-shell map-search-mobile"}>
        {loading && <div style={{width: '100%', height: '100%', zIndex:99999, backgroundColor:'rgba(255,255,255,0.05)', borderRadius: 14}} className={"Absolute Top0px Left0px"}></div>}

        <button
          type="button"
          className="map-search-icon-btn map-search-menu-btn"
          onClick={() => {this.props.sideMenuFunction(!this.props.sideMenu)}}
          aria-label="Open side menu"
        >
          <FontAwesomeIcon icon={"bars"} />
        </button>

        <input
          className={"map-search-input map-search-input-mobile"}
          type="text"
          value= {this.state.value}
          placeholder="Search a place"
          onChange={(e) => {this.setSearchText(e.target.value);this.props.onChange(e.target.value);}}
          onKeyDown={e => {this.handleKeys(e, activeList.length)}}
          onTouchStart={onFocus}
          onClick={this.handleInputFocus}
          onFocus={this.handleInputFocus}
          onBlur={() => {setTimeout(() => this.setState({isFocused: false}), 130)}}
        />

        <div className="map-search-actions">
          <button
            type="button"
            className={"map-search-icon-btn " + (loading ? "is-loading" : "")}
            onClick={() => {this.props.onRefresh()}}
            aria-label="Refresh map data"
          >
            <FontAwesomeIcon icon={"redo"} className={(loading ? 'Spin' : '')} />
          </button>

          {showFilter && (
            <button
              type="button"
              className="map-search-icon-btn"
              onClick={() => {if(this.props.onFilter){this.props.onFilter();}}}
              aria-label="Open filters"
            >
              <FontAwesomeIcon icon={"filter"} />
            </button>
          )}
        </div>
        </div>

        {type !== 'fake' && showSuggestions && (
          <ListApp
            type={"search"}
            custom={"FS35"}
            styleList={{ class: "Absolute Wide100 Left0px z300 map-search-suggestions", style: "" }}
            data={activeList}
            historyMode={isHistoryMode}
            onDelete={(entry) => { this.handleDeleteHistoryEntry(entry); }}
            onSelected={e =>{
              this.handlePlaceSelection(e, onSubmit);
            }}
            selectedItem={this.state.selectedItem}
          />
        )}

      </div>
    );
  }

  handleKeys = (e, length) =>{
    let temp;
    if(length === 0){length=1;}
    if (e.keyCode === 13) {this.returnSuggestion();}
    if (e.keyCode === 27) {this.setState({isFocused: false});}
    if (e.keyCode === 38) {
      temp = this.state.selectedItem;temp--;temp = Math.max(temp, 0);
      this.setState({selectedItem: temp});
    }
    //DOWN 40
    if (e.keyCode === 40) {
      temp = this.state.selectedItem;temp++;temp = Math.min(temp, length-1);
      this.setState({selectedItem: temp});
    }
  }

  setSearchText = (e)  => {
    // console.log('SETSEARCHTEXT => ', e);
    this.setState({value: e});
  }

  handleInputFocus = () => {
    this.refreshSearchHistory();
    this.setSearchText('');
    this.props.onChange('');
    this.setState({isFocused: true, selectedItem: -1});
    if(this.props.onFocus){this.props.onFocus();}
  }
  
  returnSuggestion = ()  => {
    const suggestionsList = (Array.isArray(this.props.suggestions) ? this.props.suggestions : []);
    const activeList = this.getActiveSearchList(suggestionsList);
    if(activeList.length > 0){
      const targetIndex = (this.state.selectedItem < 0 ? 0 : this.state.selectedItem);
      this.handlePlaceSelection(activeList[targetIndex], this.props.onSubmit);
    }
    else{ if(this.state.value !== ''){this.props.onSubmit(this.lastSent);}}
  }

  getActiveSearchList = (suggestionsList) => {
    const hasValue = (this.state.value && this.state.value.trim().length > 0);
    return (hasValue ? suggestionsList : this.state.searchHistory);
  }

  refreshSearchHistory = () => {
    this.setState({searchHistory: getSearchHistory()});
  }

  persistSearch = (placeName, center) => {
    const nextHistory = saveSearchHistoryEntry(placeName, center);
    this.setState({searchHistory: nextHistory});
  }

  handlePlaceSelection = (entry, onSubmit) => {
    if (!entry) {
      return;
    }

    const label = (entry.place || entry.place_name || '').toString();
    this.setSearchText(label);
    this.persistSearch(label, entry.center);
    onSubmit(this.formatCoordinates(entry));
    this.setState({isFocused: false, selectedItem: -1});
  }

  handleDeleteHistoryEntry = (entry) => {
    const label = (entry && entry.place_name ? entry.place_name : '').toString();
    if (!label) {
      return;
    }

    const nextHistory = removeSearchHistoryEntry(label);
    this.setState((prevState) => ({
      searchHistory: nextHistory,
      selectedItem: (nextHistory.length > 0 ? Math.min(Math.max(prevState.selectedItem, 0), nextHistory.length - 1) : -1)
    }));
  }
 
  formatCoordinates = (e) => {
    const temp = {'latitude': e['center'][1], 'longitude': e['center'][0]};
    this.lastSent = temp;
    // console.log('RETURN SUGGESTION => ', temp);
    return temp
  }

}

const mapStateToProps = (state) => { return {sideMenu: state.sideMenu, isAuthenticated: state.status.token !== null && state.status.token !== '' ? true : false, status:state.status, user:state.user, settings:state.settings, architecture:state.architecture};}
const mapDispatchToProps = dispatch => {
  return {
      sideMenuFunction: (bVal) => dispatch(actions.sideMenu(bVal)),
      onTryAutoSignup: (history) => dispatch(actions.authCheckState(history)),
      navigate: (direction, history) => dispatch(actions.navigate(direction, history))
  }}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchMenuBar));
